var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vxe-modal',{ref:"modal",attrs:{"title":"选择合同模板","width":"80%","height":"90%"},model:{value:(_vm.formVisible),callback:function ($$v) {_vm.formVisible=$$v},expression:"formVisible"}},[_c('div',{staticClass:"select-panel"},[_c('div',{staticClass:"select-table"},[_c('vxe-grid',{ref:"xTable",attrs:{"resizable":"","column-config":{ minWidth: '80px' },"data":_vm.tableData,"showOverflow":true,"size":"mini","mouse-config":{ area: true },"tooltip-config":{
            showAll: true,
            theme: 'dark'
          },"pager-config":_vm.tablePage,"seq-config":{
            startIndex: (_vm.tablePage.currentPage - 1) * _vm.tablePage.pageSize
          },"highlight-hover-row":"","highlight-current-row":"","height":"100%","columns":_vm.gridColumns,"keyboard-config":{
            isArrow: true,
            isEnter: true,
            isTab: true,
            isClip: true,
            enterToTab: true,
            isEdit: true
          },"scroll-y":{
            mode: 'wheel'
          }},on:{"page-change":_vm.handlePageChange}})],1),_c('div',{staticClass:"operate-area"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.handleSelect}},[_vm._v("选择")]),_c('el-button',{attrs:{"type":"danger"},on:{"click":function($event){_vm.formVisible = false}}},[_vm._v("取消")])],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }